import { instantMeiliSearch } from '@meilisearch/instant-meilisearch';
import { createContext, useMemo } from 'react';
import { InstantSearch } from 'react-instantsearch-dom';
import { useAuthUser } from '../../../hooks/useUser';
import AllOrganizationList from '../../Organizations/AllOrganizationsList';

const SEARCH_HOST = import.meta.env.VITE_SEARCH_HOST;
const INDEX_NAME = 'organizations';
const PRIMARY_KEY = 'id';

export const OrganizationContext = createContext();

export default function OrganizationProvider({ children }) {
  const { token } = useAuthUser();

  const searchClient = useMemo(() => {
    let client = undefined;

    if (!!SEARCH_HOST && !!token) {
      // Use auth token to search server.
      client = instantMeiliSearch(SEARCH_HOST, token, {
        primaryKey: PRIMARY_KEY,
      });
    }

    return client;
  }, [token]);

  if (!token)
    return (
      <div className="flex items-center justify-center p-4">
        <p className="text-center">Initializing search...</p>
      </div>
    );

  return (
    <OrganizationContext.Provider
      value={{
        searchClient,
      }}
    >
      {searchClient ? (
        <InstantSearch indexName={INDEX_NAME} searchClient={searchClient}>
          {children}
        </InstantSearch>
      ) : (
        <AllOrganizationList />
      )}
    </OrganizationContext.Provider>
  );
}
